import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import KaroIcon from "../Icons/KaroIcon";
import KupaIcon from "../Icons/KupaIcon";
import MacaIcon from "../Icons/MacaIcon";
import SinekIcon from "../Icons/SinekIcon";
export var CardSuit = function (_a) {
    var suit = _a.suit;
    var renderSuitIcon = function () {
        switch (suit) {
            case "hearts":
                return _jsx(KupaIcon, {});
            case "diamonds":
                return _jsx(KaroIcon, {});
            case "clubs":
                return _jsx(SinekIcon, {});
            case "spades":
                return _jsx(MacaIcon, {});
            default:
                return null;
        }
    };
    return _jsx(_Fragment, { children: renderSuitIcon() });
};
export default CardSuit;
